import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HttpService } from '@core/services';
import { AccountingHttpService } from '@core/services/http';
import { AccountingActions } from '@store/actions';
import { AccountingSelectors } from '@store/selectors';

type Tab = 'summary' | 'financial';

export const useAccountingTabPrefetch = (
  currentTab: Tab,
  projectBundleID: string,
) => {
  const dispatch = useDispatch();

  const financialLoaded = useSelector(
    AccountingSelectors.getFinancialTabIsLoaded,
  );

  useEffect(() => {
    const prefetchDelay = 1000;

    const prefetchMap: Partial<Record<Tab, Tab[]>> = {
      summary: ['financial'],
    };

    const loadingStates = {
      financial: financialLoaded,
    };

    const timer = setTimeout(() => {
      prefetchMap[currentTab]?.forEach(async (tabName: Tab) => {
        if (!loadingStates[tabName as keyof typeof loadingStates]) {
          dispatch(AccountingActions.setFinancialTabLoading.done(true));

          switch (tabName) {
            case 'financial':
              await HttpService.getHttpRequests(
                AccountingHttpService,
              ).getAccountingFinancial(projectBundleID, {
                silent: true,
              });

              break;

            default:
              break;
          }
        }
      });
    }, prefetchDelay);

    return () => clearTimeout(timer);
  }, [currentTab, financialLoaded]);
};
